define('views/space_switcher/Podio.Views.SpaceSwitcher',['require','translate','underscore','jquery','lib/backbone/Backbone.PodioView','views/space_switcher/Podio.Views.SpaceSwitcherSearchResult','lib/Podio.UI.Tooltips','lib/Podio.UI','lib/Podio.Browser','lib/GlobalEventBus','jst!space_switcher/_space_switcher'],function(require) {

  var t = require('translate');
  var _ = require('underscore');
  var $ = require('jquery');
  var PodioView = require('lib/backbone/Backbone.PodioView');
  var SearchResultView = require('views/space_switcher/Podio.Views.SpaceSwitcherSearchResult');
  var Tooltips = require('lib/Podio.UI.Tooltips');
  var podioUI = require('lib/Podio.UI');
  var browser = require('lib/Podio.Browser');
  var keyCodes = podioUI.KeyCodes;
  var globalEvent = require('lib/GlobalEventBus');

  var jstSpaceSwitcher = require('jst!space_switcher/_space_switcher');

  return PodioView.extend({

    className: 'space-switcher',

    podioEvents: {
      'input input[type=text]'           : 'onSearchInputChanged',
      'keydown default input[type=text]' : 'onSearchKeydown',
      'keyup input[type=text]'           : 'onSearchKeyup',
      'click .search:not(.activated)'    : 'onWrapperClick',
      'click .search.activated .icon'    : 'onCloseClick'
    },

    shortcuts: {
      'esc'   : 'onShortcutClosePressed'
    },

    initialize: function() {
      this.bindAll('onOutsideClick', 'secondaryActionClicked');

      this._super();

      this.elmContainer = this.getOption('elmContainer');
      this.visible = false;

      this._bindEvents();
    },

    _bindEvents: function() {
      globalEvent.on('spaceswitcher:hide', this.hide.bind(this));
    },

    render: function() {
      this.elmContainer.empty();

      this.elm.html(this.getTemplate(jstSpaceSwitcher, {
        translations: {
          defaultTitle: t('Choose a workspace #updated_navigation')
        }
      }));
      this.elm.appendTo(this.elmContainer);
      this.elmSearch = this.elm.find('.search');
      this.elmSearchInput = this.elmSearch.find('input[type=text]');
      this.elmTitle = this.elmSearch.find('.default-title');
      this.elmSearchIcon = this.elmSearch.find('.icon');
      this.enableShortcuts();

      this.elmSidebar = this.elm.find('.space-switcher-sidebar');
      this.elmSearchContainer = this.elm.find('.search-result-container');
      this.elmSearchBlankSlate = this.elm.find('.search-blank-slate');

      this.elmLeftNav = this.elm.find('.left-nav-container');

      // Setting up search results view
      this.searchResult = new SearchResultView({
        eventBus: this.eventBus,
        elmContainer: this.elmSearchContainer,
        collection: this.getOption('searchResultCollection')
      });

      this.listenTo(this.searchResult, 'spaceSwitcher:secondaryActionClicked', this.secondaryActionClicked);

      this.searchResult.render();
    },

    secondaryActionClicked: function() {
      this.hide();
    },

    hide: function() {
      this.elmSearchIcon.addClass('icon-16-hamburger').removeClass('icon-16-white-magnifier');
      this.elmTitle.show();
      this.elmSearchInput.hide();
      this.elmSearch.removeClass('activated');
      this.elm.off('outsideclick', this.onOutsideClick);
      this.elmSidebar.off(browser.cssTransitionEndEvent, this._onSidebarTransitionEnd.bind(this));
      this.elmSidebar.removeClass('visible');
      this.visible = false;
    },

    show: function() {
      var self = this;
      this.elmSearchIcon.removeClass('icon-16-hamburger').addClass('icon-16-white-magnifier');
      this.elmTitle.hide();
      this.elmSearchInput.val('').show().focus();
      this.elmSearch.addClass('activated');
      this.elm.on('outsideclick', this.onOutsideClick);

      this.toggleSearchResultsContainer(false);
      this.toggleSearchBlankSlate(false);
      this.elmSidebar.on(browser.cssTransitionEndEvent, this._onSidebarTransitionEnd.bind(this));
      this.elmSidebar.addClass('visible');

      this.toggleLeftNav(true);

      this.trigger('SpaceSwitcher:show');

      this.visible = true;
    },

    _onSidebarTransitionEnd: function() {
      Tooltips.hideAll();
      this.elmSearch.removeClass('tooltip');
    },

    showLeftNav: function() {
      this.toggleSearchBlankSlate(false);
      this.toggleSearchResultsContainer(false);
      this.toggleLeftNav(true);
    },

    showSearchResultsContainer: function() {
      this.toggleLeftNav(false);
      this.toggleSearchBlankSlate(false);
      this.toggleSearchResultsContainer(true);
    },

    showBlankSlate: function() {
      this.toggleLeftNav(false);
      this.toggleSearchBlankSlate(true);
      this.toggleSearchResultsContainer(false);
    },

    toggleSearchResultsContainer: function(toggle) {
      this.elmSearchContainer.toggle(toggle);
    },

    toggleSearchBlankSlate: function(toggle) {
      this.elmSearchBlankSlate.toggle(toggle);
    },

    toggleLeftNav: function(toggle) {
      this.elmLeftNav.toggle(toggle);
    },

    performSearch: function() {
      if (this.elmSearchInput.val()) {
        this.searchQuery = this.elmSearchInput.val();
        this.trigger('SpaceSwitcher:search', this.searchQuery);
      }
    },

    onOutsideClick: function(e) {
      if ($(e.target).parents('.org-spaces').length || $(e.target).parents('.search').length) {
        return;
      }
      this.hide();
    },

    onSearchInputChanged: function(elmTarget, e) {
      Tooltips.hideAll();

      this.searchQuery = elmTarget.val();
      this.trigger('SpaceSwitcher:search', this.searchQuery);
    },

    onSearchKeydown: function(elmTarget, e) {
      if (this.visible && e.keyCode === keyCodes.Esc) {
        elmTarget.blur();
        this.hide();
        e.stopPropagation();
      }
      else {
        if (this.searchResult) {
          this.searchResult.onKeyDown(elmTarget, e);
        }
      }
    },

    onSearchKeyup: function(elmTarget, e) {
      if (this.searchResult) {
        this.searchResult.onKeyUp(elmTarget, e);
      }
    },

    onWrapperClick: function(elmTarget, e) {
      this.show();
    },

    onCloseClick: function(elmTarget, e) {
      this.hide();
    },

    onShortcutShowPressed: function() {
      if (!this.visible) {
        this.show();
      }
    },

    onShortcutClosePressed: function(elmTarget, e) {
      if (this.visible) {
        this.hide();
        e.stopPropagation();
      }
    }

  });
});

